/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    variant: "tertiary",
    css: css`
        height: 100%;
        margin-left: 10px;
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            @media (max-width: 1024px) and (min-width: 769px) {
                input {
                    min-height: 42px;
                }
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
    },
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        min-width: 125px;
        @media (max-width: 1024px) and (min-width: 769px) {
            margin-left: 10px;
        }
    `,
};